import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { handleActions } from 'redux-actions';
import diff from 'deep-diff';
import moment from 'moment';
import CTModal from '../helpers/CTModal';
import { SAVE_LEVEL } from '../../constants/Level';
import { APP_LEAVING, LOGIN_SET_THEME } from '../../constants/ActionTypes';
import { ThemeService, checkIfThemeExists, saveThemeCodeToFrontman } from '../../services/ThemeService';
import {
    ConfigurationService,
    checkIfTemplateExists,
    saveTemplateToFrontman
} from '../../services/ConfigurationService';
import ModalManageContentInfoRow from './modalContent/ModalManageContentInfoRow';
import ModalManageContentInfoRowDiffData from './modalContent/ModalManageContentInfoRowDiffData';
import { ModalContentConfigForm } from './modalContent/ModalContentConfigForm';
import { checkPermissionForLevel } from '../../../lib/utils';
import { ACCESS_POINT_LEVEL, ACCESS_POINTS_GROUP, CONTENT_TYPES } from '../../constants/AccessPoints';
import { RESTORE_STATUS } from '../../constants/RestoreStatus';

class ModalManageContentInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: undefined,
            compareData: [],
            showDetails: false,
            showUpdateConfig: false,
            saveRestoreData: {
                selectedOption: 'option1'
            },
            errorForm: false
        };

        this.showDetails = this.showDetails.bind(this);
        this.updateObject = this.updateObject.bind(this);
        this.createObject = this.createObject.bind(this);
    }

    updateObject(contentType, elem) {
        const { chainId, hotelId, selectedLevel } = this.props;
        const contentCode = _.get(this.props, 'content.ContentCode', '');
        const contentName = _.get(this.state, 'current.MetaData.Name', '');
        const contentComment = _.get(this.state, 'saveRestoreData.restore.themeComment', '');
        const combinedObj = {
            Data: elem.Data,
            MetaData: {
                Name: contentName,
                Comment: contentComment
            }
        };

        if (contentType === CONTENT_TYPES.THEME) {
            ThemeService.update(chainId, hotelId, contentCode, combinedObj, selectedLevel).then(() => {
                ThemeService.all(chainId, hotelId, contentCode, selectedLevel).then(() => {
                    checkIfThemeExists({ chainId: chainId, hotelId: hotelId, shellCode: contentCode }).then(
                        response => {
                            if (!response) {
                                saveThemeCodeToFrontman({
                                    code: contentCode,
                                    chainId: chainId,
                                    hotelId: hotelId,
                                    saveLevel: selectedLevel,
                                    name: contentName
                                });
                            }
                            ThemeService.reload(chainId, hotelId, selectedLevel, contentCode, true);
                            this.closePopup();
                        }
                    );
                });
            });
        } else if (contentType === CONTENT_TYPES.CONFIG) {
            ConfigurationService.update(chainId, hotelId, contentCode, combinedObj, selectedLevel).then(() =>
                ConfigurationService.all(chainId, hotelId, contentCode, selectedLevel).then(() => {
                    checkIfTemplateExists({ chainId: chainId, hotelId: hotelId, templateCode: contentCode }).then(
                        response => {
                            if (!response) {
                                saveTemplateToFrontman({
                                    code: contentCode,
                                    chainId: chainId,
                                    hotelId: hotelId,
                                    saveLevel: selectedLevel,
                                    name: contentName
                                });
                            }
                            ThemeService.reload(chainId, hotelId, selectedLevel, contentCode, true);
                            this.closePopup();
                        }
                    );
                })
            );
        } else if (contentType === CONTENT_TYPES.THIRD_PARTY) {
            // TODO: handle version history of thirdparty
        }
    }

    createObject(contentType) {
        const { chainId, hotelId, selectedLevel } = this.props;
        const themeCode = _.get(this.state, 'saveRestoreData.save.themeCode', '');
        const themeComment = _.get(this.state, 'saveRestoreData.save.themeComment', '');
        const themeName = _.get(this.state, 'saveRestoreData.save.themeName', '');
        const combinedObj = {
            Data: Object.assign(this.state.current.Data),
            MetaData: {
                Comment: themeComment,
                Name: themeName
            }
        };

        if (contentType === CONTENT_TYPES.THEME) {
            ThemeService.new(chainId, hotelId, themeCode, combinedObj, selectedLevel).then(() => {
                ThemeService.all(chainId, hotelId, themeCode, selectedLevel).then(() => {
                    ThemeService.reload(chainId, hotelId, selectedLevel).then(() => {
                        checkIfThemeExists({ chainId, hotelId, shellCode: themeCode }).then(response => {
                            if (!response) {
                                saveThemeCodeToFrontman({
                                    code: themeCode,
                                    chainId,
                                    hotelId,
                                    saveLevel: selectedLevel,
                                    name: themeName
                                });
                            }
                            this.closePopup();
                        });
                    });
                });
            });
        } else if (contentType === CONTENT_TYPES.CONFIG) {
            ConfigurationService.new(chainId, hotelId, themeCode, combinedObj, selectedLevel).then(() => {
                ConfigurationService.reload(chainId, hotelId, selectedLevel).then(() => {
                    checkIfTemplateExists({ chainId, hotelId, templateCode: themeCode }).then(response => {
                        if (!response) {
                            saveTemplateToFrontman({
                                code: themeCode,
                                chainId,
                                hotelId,
                                saveLevel: selectedLevel,
                                name: themeName
                            });
                        }
                        this.closePopup();
                    });
                });
            });
        }
    }

    compareJsonFiles(clickedElementIndex) {
        const dataAfterChanges = _.get(this.props, `content.Value[${clickedElementIndex}].Data`, {});
        const dataPrevious = _.get(this.props, `content.Value[${clickedElementIndex + 1}].Data`, {});
        const diffData = diff(dataPrevious, dataAfterChanges);

        return diffData ? diffData : [];
    }

    showDetails(elem, clickedElementIndex) {
        const compareData = this.compareJsonFiles(clickedElementIndex);

        this.setState({
            clickedElem: elem,
            showDetails: !this.state.showDetails,
            compareData
        });
    }

    hasAccessToRestore(contentType) {
        return (
            (contentType === CONTENT_TYPES.THEME && this.props.hasAccessThemesEdit) ||
            (contentType === CONTENT_TYPES.CONFIG && this.props.hasAccessConfigurationEdit)
        );
    }

    restoreElem(elem) {
        this.setState({
            current: elem ? elem : this.state.clickedElem,
            showDetails: false,
            showUpdateConfig: true
        });
    }

    closePopup() {
        this.props.close();
        this.setState({
            current: undefined,
            compareData: [],
            showDetails: false,
            showUpdateConfig: false
        });
    }

    validateForm() {
        if (
            _.get(this.state, 'saveRestoreData.save.themeName', '') !== '' &&
            _.get(this.state, 'saveRestoreData.save.themeCode', '') !== ''
        ) {
            this.setState({
                errorForm: false
            });
            return true;
        } else {
            this.setState({
                errorForm: true
            });
            return false;
        }
    }

    updateCurrentElemByRestore(contentType) {
        if (this.state.saveRestoreData.selectedOption === 'option1') {
            this.updateObject(contentType, this.state.current);
        } else if (this.validateForm() && this.state.saveRestoreData.selectedOption === 'option2') {
            this.createObject(contentType, this.props);
        }
    }

    render() {
        const contentCode = _.get(this.props, 'content.ContentCode', '');
        const contentType = _.get(this.props, 'content.ContentId', '').split(':')[3];
        const defaultContent = _.get(this.props.selected, 'defaultContent.code', '');
        const defaultContentConfig = _.get(this.props.selected, 'defaultContentConfig.code', '');

        if (this.state.showUpdateConfig) {
            return (
                <CTModal
                    className="version-history"
                    primaryButton={this.hasAccessToRestore(contentType)}
                    primaryButtonTitle={'Save'}
                    primaryButtonClick={() => this.updateCurrentElemByRestore(contentType)}
                    secondaryButton={true}
                    secondaryButtonTitle={'Close'}
                    secondaryButtonClick={() => this.closePopup()}
                    previousButton={true}
                    previousButtonTitle={`Back to version history`}
                    previousButtonClick={() => {
                        this.setState({
                            showDetails: false,
                            showUpdateConfig: false
                        });
                    }}
                    onClose={() => {
                        this.closePopup();
                    }}
                    open={this.props.open}
                >
                    <div className="col-xs-12">
                        <h3>Save {_.startCase(_.toLower(contentType))} Changes</h3>
                        <p>APPLY CHANGES TO</p>
                        <ModalContentConfigForm
                            contentType={contentType}
                            errorForm={this.state.errorForm}
                            onChange={elements => {
                                this.setState({
                                    saveRestoreData: elements
                                });
                            }}
                        />
                    </div>
                </CTModal>
            );
        } else if (this.props.content && !this.state.showDetails) {
            return (
                <CTModal
                    className="version-history"
                    primaryButtonTitle={'Close'}
                    primaryButton={true}
                    primaryButtonClick={() => this.closePopup()}
                    onClose={() => this.closePopup()}
                    open={this.props.open}
                >
                    <div>
                        <h1>Version History</h1>
                        <h4>
                            {_.upperFirst(contentType)}
                            <b>{` ${contentCode}`}</b>
                            {(contentCode === defaultContent || contentCode === defaultContentConfig) && ' (Default)'}
                        </h4>
                        <table className="spark-table restore-modal col-xs-12" role="grid">
                            <thead>
                                <tr>
                                    <th>Date saved</th>
                                    <th>User</th>
                                    <th>Comments</th>
                                    <th>Restore</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.content.Value.map((elem, index) => {
                                    return (
                                        <ModalManageContentInfoRow
                                            key={index}
                                            showViewDetails={true}
                                            userName={elem.MetaData.User}
                                            comment={elem.MetaData.Comment}
                                            updatedTime={elem.MetaData.Timestamp}
                                            compareData={this.compareJsonFiles(index)}
                                            showDetails={() => this.showDetails(elem, index)}
                                            showRestore={
                                                index === 0
                                                    ? RESTORE_STATUS.CURRENT
                                                    : this.hasAccessToRestore(contentType)
                                                    ? RESTORE_STATUS.RESTORE
                                                    : ''
                                            }
                                            restoreElem={() => this.restoreElem(elem, contentType)}
                                            index={index}
                                        />
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </CTModal>
            );
        } else if (this.props.content && this.state.showDetails) {
            return (
                <CTModal
                    className="version-history"
                    primaryButton={
                        this.props.content.Value[0].MetaData.Timestamp !== this.state.clickedElem.MetaData.Timestamp
                            ? this.hasAccessToRestore(contentType)
                            : false
                    }
                    primaryButtonTitle={'Restore'}
                    primaryButtonClick={() => this.restoreElem()}
                    secondaryButton={true}
                    secondaryButtonTitle={'Close'}
                    secondaryButtonClick={() => this.closePopup()}
                    previousButton={true}
                    previousButtonTitle={`Back to version history`}
                    previousButtonClick={() => {
                        this.setState({
                            showDetails: false
                        });
                    }}
                    onClose={() => {
                        this.closePopup();
                    }}
                    open={this.props.open}
                >
                    <div>
                        <h1>
                            Change Log of <b>{contentCode}</b>
                        </h1>
                        <h4>
                            {'Date saved: '}
                            <b>
                                {moment
                                    .utc(_.get(this.state.clickedElem, 'MetaData.Timestamp', ''))
                                    .format('MM/DD/YYYY')}
                            </b>
                            {' at: '}
                            <b>{moment.utc(_.get(this.state.clickedElem, 'MetaData.Timestamp', '')).format('HH:mm')}</b>
                            {' by user: '}
                            <b>{_.get(this.state.clickedElem, 'MetaData.User', '')}</b>
                        </h4>
                        {this.state.compareData.length > 0 ? (
                            <table className="spark-table restore-modal col-xs-12" role="grid">
                                <thead>
                                    <tr>
                                        <th>What changed</th>
                                        <th>Previous</th>
                                        <th>
                                            <b>Changed to</b>
                                        </th>
                                    </tr>
                                </thead>
                                <ModalManageContentInfoRowDiffData compareData={this.state.compareData} />
                            </table>
                        ) : (
                            <h6>Nothing has changed.</h6>
                        )}
                    </div>
                </CTModal>
            );
        } else {
            return <CTModal className="version-history" />;
        }
    }
}

ModalManageContentInfo.propTypes = {
    close: PropTypes.func,
    open: PropTypes.bool,
    content: PropTypes.object,
    history: PropTypes.object,
    selectedLevel: PropTypes.string
};

ModalManageContentInfo.contextTypes = {
    store: PropTypes.object
};

ModalManageContentInfo.defaultProps = {
    selectedLevel: SAVE_LEVEL.HOTEL
};

const mapContentInfoStateToProps = state => {
    const { content } = state.app.modal.contentInfo;
    let history = {};
    if (content && state.manage.history && state.manage.history.themes && state.manage.history.themes) {
        history = content.type === 'theme' ? state.manage.history.themes : state.manage.history.configs;
    }

    return {
        open: state.app.modal.contentInfo.isOpened,
        content,
        history,
        selected: state.app.selected,
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        selectedLevel: state.app.selected.level,
        hasAccessThemesEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.THEMES,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        ),
        hasAccessConfigurationEdit: checkPermissionForLevel(
            state.oauth.accessLevel,
            ACCESS_POINTS_GROUP.CONFIGURATION,
            ACCESS_POINT_LEVEL.EDIT,
            state.oauth.userPermissionLevels,
            state.app.selected.level
        )
    };
};

const mapContentInfoDispatchToProps = dispatch => {
    return {
        close() {
            dispatch(modalContentInfoActions.hide());
        }
    };
};

const WrappedModalManageContentInfo = connect(
    mapContentInfoStateToProps,
    mapContentInfoDispatchToProps
)(ModalManageContentInfo);

const modalContentInfoActions = {
    show(content) {
        return dispatch => {
            dispatch({ type: 'ModalOpenContentInfo', content });
        };
    },
    hide() {
        return dispatch => {
            dispatch({ type: 'ModalCloseContentInfo' });
        };
    },
    setTheme: (theme, code) => {
        dispatch({ type: LOGIN_SET_THEME, theme, code });
    }
};

const modalContentInfoReducer = handleActions(
    {
        ['ModalOpenContentInfo']: (state, action) => {
            return { ...state, isOpened: true, content: action.content };
        },
        ['ModalCloseContentInfo']: state => {
            return { ...state, isOpened: false };
        },
        [APP_LEAVING]: () => {
            return { isOpened: false };
        }
    },
    { isOpened: false }
);

export { WrappedModalManageContentInfo as ModalManageContentInfo, modalContentInfoReducer, modalContentInfoActions };



// WEBPACK FOOTER //
// ./src/components/modals/ModalManageContentInfo.js